export default __webpack_public_path__ + "static/media/activity-6.39ec3ac4.png";